import React from 'react';
import { Path, Svg, type SvgProps } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

export interface GoogleFlatIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

const GoogleFlatIcon: React.FC<GoogleFlatIconProps> = ({
  size = 64,
  color = 'iconPrimary',
  ...props
}) => {
  const { theme: colors } = useUnistyles();
  return (
    <Svg {...props} width={size} height={size} viewBox="0 0 16 16">
      <Path
        fill={colors[color]}
        stroke="none"
        d="m15.9914 8.1497c0-.65551-.0545-1.13386-.1723-1.62992h-7.65992v2.95865h4.49622c-.0906.73527-.5801 1.84257-1.6679 2.58667l-.0153.099 2.4219 1.8335.1678.0163c1.5411-1.3907 2.4295-3.437 2.4295-5.8642z"
      />
      <Path
        fill={colors[color]}
        stroke="none"
        d="m8.15943 15.9451c2.20277 0 4.05207-.7087 5.40277-1.9311l-2.5745-1.9489c-.6889.4695-1.61358.7972-2.82827.7972-2.15747 0-3.9886-1.3907-4.64135-3.31298l-.09568.00794-2.518372 1.90454-.032934.0895c1.341616 2.6043 4.097406 4.3938 7.288336 4.3938z"
      />
      <Path
        fill={colors[color]}
        stroke="none"
        d="m3.51818 9.54912c-.17224-.49606-.27191-1.02761-.27191-1.5768 0-.54925.09967-1.08073.26284-1.57679l-.00456-.10565-2.549922-1.93514-.083429.03878c-.552943 1.08073-.87022244 2.29435-.87022244 3.5788 0 1.28446.31727944 2.49798.87022244 3.57878z"
      />
      <Path
        fill={colors[color]}
        stroke="none"
        d="m8.1594 3.08269c1.53197 0 2.5654.64665 3.1546 1.18705l2.3025-2.19689c-1.4141-1.284453-3.2543-2.07285-5.4571-2.07285-3.19092 0-5.94669 1.78937-7.288306 4.39371l2.637916 2.00201c.66181-1.92225 2.49293-3.31303 4.65039-3.31303z"
      />
    </Svg>
  );
};

GoogleFlatIcon.displayName = 'GoogleFlatIcon';
export { GoogleFlatIcon };
